import React, { useEffect, useState } from "react";
import PageHeader from "../components/PageHeader";
import PageContent from "../components/PageContent";
import GalleryItem from "../components/GalleryItem";
import YoutubePlayer from "../components/YoutubePlayer";
import { useSelector } from "react-redux";
import {
  ArrowBack,
  ArrowForward,
  Close,
  DisabledByDefault,
} from "@mui/icons-material";
import VideoCard from "../components/VideoCard";

function Gallery({galleryType,gealleryHeads}) {



  // alert("galleryType : ",galleryType)
  console.log("gealleryHeads",gealleryHeads)
  const { videos, hasVideoSection } = useSelector((state) => state.auth);

  const [images, setImages] = useState([]);
  const clickTo = (index, image) => {
    if (image.post_link === null) {
      setViewImage(!viewImage);
      setCurrentImage(index);
    } else {
      window.open(image.post_link, "_blank");
    }
  };

  const galleryImages = useSelector((state) => state.auth.gallery_images);
  useEffect(() => {
    const imgs = galleryImages
      .filter((gi) => gi.title === galleryType)
      .map((e) => e.image_link);
    setImages(imgs);
  }, [galleryImages, galleryType]);

 

  const [viewImage, setViewImage] = useState(false);
  const [currentImage, setCurrentImage] = useState(0);

  return (
    <>
      {viewImage === true && (
        <div className="lightbox">
          <span className="close-btn" onClick={() => setViewImage(false)}>
            <Close style={{ color: "#fff", height: "40px", width: "40px" }} />
          </span>
          <ul style={{ margin: "50px" }}>
            <li>
              <button
                className="naving-btn btn-prev"
                onClick={
                  currentImage === 0
                    ? null
                    : () => setCurrentImage(currentImage - 1)
                }
              >
                {currentImage !== 0 ? <ArrowBack /> : <DisabledByDefault />}
              </button>
            </li>
            <li
              style={{
                display: "flex",
                flex: "1",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                style={{
                  maxWidth: "90vw",
                  maxHeight: "80vh",
                  objectFit: "contain",
                  display: "block",
                  margin: "auto",
                }}
                alt="hello"
                src={images[currentImage]}
              />
            </li>
            <li>
              <button
                className="naving-btn btn-next"
                onClick={
                  images.length === currentImage + 1
                    ? null
                    : () => setCurrentImage(currentImage + 1)
                }
              >
                {images.length !== currentImage + 1 ? (
                  <ArrowForward />
                ) : (
                  <DisabledByDefault />
                )}
              </button>
            </li>
          </ul>
        </div>
      )}
      <div>

        
        <PageHeader title={`${galleryType}`} />

        <PageContent
          elem={
           galleryType === "video" ? (
              <div className="video-section">
                {videos.map((videos) => (
                  <VideoCard
                    videoUrl={videos.video_link}
                    customThumbnail={`${
                      videos.thumbnail_link === "#"
                        ? "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQykzoZeCE0p7LeuyHnLYCdPP2jju9d5PaMeA&s"
                        : videos.thumbnail_link
                    }`}
                  />
                ))}
              </div>
            ) : (
              <ul id="gallery-ul">
                {galleryImages
                  .filter((gi) => gi.title === galleryType)
                  .map((img, index) => (
                    <li key={index}>
                      <GalleryItem
                        image={img}
                        clickTo={() => clickTo(index, img)}
                      />
                    </li>
                  ))}
              </ul>
            )
          }
        />
      </div>
    </>
  );
}

export default Gallery;
